/* Live per-box line on needle product pages, and per-box price in the cart. */
(function () {
  'use strict';
  var NEEDLE = /^premium-acupuncture-needles(-\d)?$/;
  function money(c, cur) {
    try { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: cur || 'USD' }); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* Product page */
  var pdp = document.querySelector('[data-tc-pdp][data-kind="needle"]');
  if (pdp) {
    var main = pdp.querySelector('.buy__main');
    if (main) {
      var line = document.createElement('p');
      line.className = 'mono stat pdp-line';
      line.setAttribute('aria-live', 'polite');
      line.hidden = true;
      main.insertAdjacentElement('afterend', line);
      var paint = function (cart) {
        if (!cart || !cart.items) return;
        var n = 0, cents = 0;
        cart.items.forEach(function (it) {
          if (NEEDLE.test(it.handle || '')) { n += it.quantity; cents += it.final_line_price; }
        });
        if (n < 1) { line.hidden = true; return; }
        line.innerHTML = '<b>' + n + (n === 1 ? ' box' : ' boxes') + '</b> in your cart · ' +
          money(Math.round(cents / n), cart.currency) + '/box · ' + money(cents, cart.currency);
        line.hidden = false;
      };
      document.addEventListener('tenchi:cart', function (e) { if (e.detail && e.detail.items) paint(e.detail); else getCart().then(paint); });
      getCart().then(paint).catch(function () {});
    }
  }

  /* Cart page */
  var page = document.querySelector('[data-tc-cart-page]');
  if (page) {
    var busy = false;
    var apply = function () {
      if (busy) return;
      getCart().then(function (cart) {
        busy = true;
        var byKey = {};
        cart.items.forEach(function (it) { byKey[it.key] = it; });
        page.querySelectorAll('.tline[data-key]').forEach(function (li) {
          var it = byKey[li.getAttribute('data-key')];
          var each = li.querySelector('.tline__n > .mono');
          if (!it || !each || li.querySelector('.tline__box') || !NEEDLE.test(it.handle || '')) return;
          var box = document.createElement('span');
          box.className = 'mono tline__box';
          box.innerHTML = (it.final_price < it.original_price ? '<s>' + money(it.original_price, cart.currency) + '</s>' : '') +
            money(it.final_price, cart.currency) + ' / box';
          each.replaceWith(box);
        });
        busy = false;
      }).catch(function () { busy = false; });
    };
    apply();
    new MutationObserver(function () { if (!busy) apply(); }).observe(page, { childList: true, subtree: true });
  }
})();
